const DESCRIBED_BY = 'aria-describedby'
const HIDDEN = 'aria-hidden'

export { DESCRIBED_BY, HIDDEN }
